import { CreateContactInput } from '@admiin-com/ds-graphql';
import { Bill } from '../PayBillCreateForm';

export const getContactCreateInputFromBill = (bill?: Bill | null) => {
  if (!bill) {
    return null;
  }

  const { from, to, bpay, bank } = bill;
  if (from && to && !('id' in from)) {
    const bankName =
      from.name ??
      (from.firstName && from.lastName
        ? `${from.firstName} ${from.lastName}`
        : null);
    const createContactInput: CreateContactInput = {
      firstName: from.firstName ?? '',
      lastName: from.lastName ?? '',
      email: from.email ?? null,
      phone: from.phone ?? null,
      name: from.name ?? '',
      taxNumber: from.taxNumber,
      entityId: to.id,
      bank:
        bank && bank.accountNumber && bank.routingNumber
          ? {
              bankName: bankName ?? null,
              accountName: bankName ?? '',
              accountNumber: bank.accountNumber ?? '',
              routingNumber: bank.routingNumber ?? '',
            }
          : null,
      bpay:
        bpay && bpay.billerCode
          ? // (bpay.referenceNumber && saveBpayRefForFuture)
            {
              billerCode: bpay.billerCode ?? null,
              referenceNumber: bpay.referenceNumber ?? null,
            }
          : null,
    };
    return createContactInput;
  }
  return null;
};
